export default __webpack_public_path__ + "static/media/clock.3ecab054.svg";